import React, {  } from 'react';
import { Modal, Box, Typography, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { flatten } from 'lodash';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import SaveIcon from '@mui/icons-material/Save';
import { CalendarError } from '~/utils/eventsHelper';
import { useZonedDateFormat } from '~/providers/ZonedDateFormatProvider';

interface DragEventsModalErrors {
  errorsAndWarnings?: Map<string, (CalendarError | null)[]>;
  open: boolean;
  handleClose: () => void;
  onRetryDriveTimes?: () => void;
  isRetrying?: boolean;
}

const DragEventsModalErrors: React.FC<DragEventsModalErrors> = ({
  errorsAndWarnings,
  open,
  handleClose,
  onRetryDriveTimes,
  isRetrying = false,
}) => {
  const { timeLabelWithZone } = useZonedDateFormat();
  const errors = flatten(Array.from(errorsAndWarnings?.values() ?? []));

  const errorEntries = Array.from(errorsAndWarnings?.entries() ?? []).filter(
    ([, errorList]) => errorList.filter(Boolean).length > 0
  );

  // Check if there are any drive time errors (to determine if we should show the retry button)
  const hasDriveTimeErrors = errors.some(error => error?.type === 'drive_time');

  if (errorEntries.length === 0) return null;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 400,
        bgcolor: 'background.paper',
        p: 4
      }}>
        <Typography id="modal-title" variant="h6" component="h2">
          There's warning on your latest changes
        </Typography>
        <Box id="modal-description" sx={{ mt: 2 }}>

          {errorEntries.map(([visitId, errorList]) => {
              const visit = errorList[0]?.visit;
              if (!visit) return null;
              console.log('visit', visit);
              const patient = visit?.patient;
              const visitType = errorList[0]?.visitType;
              const visitTitle = visitType && patient
                ? `${visitType.name} visit for patient ${patient.firstName} ${patient.lastName} at ${timeLabelWithZone(visit.startTime, true, visit?.addressTimezone)}`
                : `Visit ${visitId}`;
              const validErrors = errorList.filter(Boolean) as CalendarError[];

              return (
                <Accordion key={visitId}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1">{visitTitle}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {validErrors.map((error, index) => (
                      <Box key={index} display="flex" alignItems="center" mb={1}>
                        {error.type === 'drive_time' && <DriveEtaIcon sx={{ mr: 1 }} />}
                        {error.type === 'save' && <SaveIcon sx={{ mr: 1 }} />}
                        <Typography>{error.message}</Typography>
                      </Box>
                    ))}
                  </AccordionDetails>
                </Accordion>
              );
            })}
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={2}>
          {hasDriveTimeErrors && onRetryDriveTimes && (
            <Button
              variant="outlined"
              color="primary"
              loading={isRetrying}
              onClick={onRetryDriveTimes}
              startIcon={<DriveEtaIcon />}
              sx={{ mr: 2 }}
            >
              Retry Drive Times
            </Button>
          )}
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            CLOSE
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DragEventsModalErrors;

